var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / happy water icon / blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-happy-water-icon-/-blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0541933,36.0287624 C22.4254616,39.1700532 25.9304511,41.4037772 30.0378595,41.4037772 C32.3654634,41.4037772 34.4996118,40.686459 36.1616385,39.4931565 L36.1704453,39.4950432 C38.4862588,38.0567175 39.7603749,36.2008514 39.9927937,33.927445 C40.1225027,32.6586955 39.8361113,31.0424003 39.144811,29.795585 C38.2956305,28.2640199 37.1039306,27.1226384 36.9404529,26.971902 C34.4710451,24.6949578 34.0504296,24.5440303 33.5256464,23.3933442 C33.2631703,22.8178158 33.1980501,22.3215646 33.1416242,21.7442728 C33.0834043,21.1486267 33.2668433,20.2338691 33.6919414,19 C31.3645073,19.8961655 29.7503035,20.5830427 28.84933,21.0606317 C26.7280686,22.1850723 25.273399,23.4243208 24.2696414,24.3072417 C23.249455,25.2046136 21.8583588,26.469856 21.1403173,27.9216487 C20.9184395,28.3702586 19.9552037,29.727289 20.0016225,32.1416839 C20.0272265,33.4734344 20.3780835,34.7691272 21.0541933,36.0287624 Z",
    id: "Combined-Shape",
    fill: "#437FCD"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.b10ca4e217d7f33a276939dfffc4fbcf.svg";
export { ForwardRef as ReactComponent };